<template>
  <div>
    <v-toolbar
      v-if="isLoggedIn && this.screenSize === 'mobile'"
      dark
      :color="this.$gf.headerColor()"
    >
      <v-app-bar-nav-icon @click="openNav = !openNav"></v-app-bar-nav-icon>
    </v-toolbar>
    <v-toolbar v-else-if="isLoggedIn" dark :color="this.$gf.headerColor()">
      <v-toolbar-items>
        <!--<v-btn text to="/super-admin/">Dashboard</v-btn>-->
        <v-btn text to="/super-admin/companies"
          >Companies</v-btn
        >
        <v-btn text to="/super-admin/partners" v-if="['partner', 'senso'].includes($globalConfig.APP_NAME)"
          >Partner</v-btn
        >
        
        <v-btn text to="/super-admin/reports" v-if="['partner', 'senso'].includes($globalConfig.APP_NAME)"
          >Reports</v-btn
        >
        <v-btn text to="/super-admin/packages" v-if="['partner'].includes($globalConfig.APP_NAME)"
          >Packages</v-btn
        >
        <v-btn text to="/super-admin/courses" v-if="['senso'].includes($globalConfig.APP_NAME)"
          >Courses</v-btn
        >
        <v-btn text to="/super-admin/contracts" v-if="['direct'].includes($globalConfig.APP_NAME)"
          >Contracts</v-btn
        >
        <v-btn text to="/super-admin/course-rollout" v-if="['direct'].includes($globalConfig.APP_NAME)"
          >Course Rollout</v-btn
        >
         <v-btn text to="/super-admin/release-notes"
          >Release Notes</v-btn
        >
        <!-- Three year agreements: term ends, notice deadlines, notices
             received (Steve, 17 Sep 2026). Direct only: Hub has no Stripe. -->
        <v-btn text to="/super-admin/renewals" v-if="['direct'].includes($globalConfig.APP_NAME)"
          >Renewals</v-btn
        >
        <v-btn text to="/super-admin/invoices" v-if="['direct'].includes($globalConfig.APP_NAME)"
          >Invoices</v-btn
        >
      </v-toolbar-items>
      <div class="flex-grow-1"></div>
      <span class="mr-4">Logged in as: {{ level }}</span>
      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-btn icon @click="logout">
          <v-icon>fa-sign-out-alt</v-icon>
        </v-btn>
      </template>
    </v-toolbar>
    <transition name="nav-slide-down">
      <div v-if="this.openNav === true && this.screenSize === 'mobile'">
        <div class="nav-menu-container">
          <v-card style="padding: 10px 15px" flat to="/super-admin/companies"
          >Companies
          </v-card>
          <v-card
            style="padding: 10px 15px"
            flat
            to="/super-admin/partners" v-if="['partner', 'senso'].includes($globalConfig.APP_NAME)"
          >Partner
          </v-card>
          
          <v-card style="padding: 10px 15px" flat to="/super-admin/reports" v-if="['partner', 'senso'].includes($globalConfig.APP_NAME)"
          >Reports</v-card
          >
          <v-card style="padding: 10px 15px" flat to="/super-admin/courses" v-if="['senso'].includes($globalConfig.APP_NAME)"
          >Courses</v-card
          >
          <v-card style="padding: 10px 15px" flat to="/super-admin/contracts" v-if="['direct'].includes($globalConfig.APP_NAME)"
          >Contracts</v-card
          >
          <v-card style="padding: 10px 15px" flat to="/super-admin/course-rollout" v-if="['direct'].includes($globalConfig.APP_NAME)"
          >Course Rollout</v-card
          >
          <v-card style="padding: 10px 15px" flat to="/super-admin/renewals" v-if="['direct'].includes($globalConfig.APP_NAME)"
          >Renewals</v-card
          >
          <v-card style="padding: 10px 15px" flat to="/super-admin/invoices" v-if="['direct'].includes($globalConfig.APP_NAME)"
          >Invoices</v-card
          >
          <span style="padding: 10px 15px">Logged in as: {{ level }}</span>
          <v-btn icon @click="logout" style="background: #000000">
            <v-icon>fa-sign-out-alt</v-icon>
          </v-btn>
          <br/>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { screensize } from '@/utils/screensize.js';
// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'SuperAdminNavigation',
  data() {
    return {
      screenSize: currentScreenSize,
      user: this.$store.getters.user.first_name,
      openNav: false,
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    level: function () {
      const user = this.$store.getters.user;
      return user.first_name + ' ' + user.last_name;
    },
    userName: function () {
      return this.$store.getters.isLoggedIn;
    },
    showAdmin: function () {
      return this.$store.getters.admin;
    },
    isSuperadmin: function () {
      if (this.$store.getters.level == 1) 
        return true;
      else
        return false;
    },
  },
  created() {
    // Add event listener for screen size changes
    window.addEventListener('resize', this.handleResize);
  },
  mounted() {
    this.handleResize();
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout').then(() => {
        localStorage.removeItem('todos');
        this.$router.push('/login');
      });
    },
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);

    this.screenSize = null;
  },
};
</script>
